<template>
	<LiteScroller
		class="lite-goal-scroller"
		:is-paging="isPaging"
		:is-paging-enabled="isPagingEnabled && !showPlaceholder"
	>
		<slot name="placeholder" v-if="showPlaceholder"></slot>
		<div v-else v-for="item in goalListItems" :key="item.keyField">
			<GoalCard
				:goal="item.goal"
				:show-skeleton="item.showSkeleton"
				:show-team-name="showTeamName"
				@goalSelected="onListItemSelected( item )"
			/>
		</div>
	</LiteScroller>
</template>

<script>
import {
	LiteScroller
} from "@teaming/common-ui";

import GoalCard from "./GoalCard";

export default {
	name: "LiteGoalScroller",
	emits: [ "goalSelected", ],
	components: {
		LiteScroller,
		GoalCard,
	},
	props: {
		/** @type {Array.<{goal:Goal, showSkeleton:Boolean, keyField:String}>} **/
		goalListItems: {
			type: Array,
			required: true,
		},
		showPlaceholder: {
			type: Boolean,
			required: true,
		},
		showTeamName: {
			type: Boolean,
			default: true,
		},
		isPagingEnabled: {
			type: Boolean,
			default: true,
		},
		isPaging: {
			type: Boolean,
			default: false,
		},
		// 	@see LiteScroller for addtl. props
	},
	methods: {
		onListItemSelected( listItem ) {
			const { goal, pageNumber, } = listItem;
			this.$emit( "goalSelected", {
				goalId: goal.id,
				pageNumber,
			} );
		},
	},
};
</script>

<style lang="scss" scoped>
.lite-goal-scroller {
	display: flex;
	flex-direction: column;
	gap: 1rem;
}
</style>

<style lang="scss">
// fix inconsistent spacing
.lite-goal-scroller.lite-scroller {
	.goal-card, .goal-card-skeleton {
		margin-bottom: 0;
	}

	.lite-scroller__scroll-content {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}
}
</style>
